import { MNavLink } from "@material-dev/insights-portal-ui-components/lib";
import { MUserMenu } from "@material-dev/insights-portal-ui-components/lib/feature-components/m-user-menu/MUserMenu";
import React, { FC, memo } from "react";
import { useAppSelector } from "@store";
import { AppNavigation, ProfileMenuNavigation } from "app/routes";
import AddProjectDialog from "components/AddProjectDialog";
import HelpHeaderItem from "./components/HeaderHelpItem";
import { useStyles } from "./AppHeaderStyles";
import MenuItem from "@mui/material/MenuItem/MenuItem";

const HeaderInfo: FC = memo(() => {
  const { currentUser } = useAppSelector((state) => state.userState);
  const { classes } = useStyles();
  const profileRouteItems = () => {    
    return (
      <>
         {ProfileMenuNavigation.filter((i) => !i.role || currentUser?.isAdmin || currentUser?.roles?.includes(i.role)).map(({ headerText, path }) => (          
            <MenuItem className={classes.menuItem}><MNavLink key={String(path)} path={path}>{headerText}  </MNavLink></MenuItem>        
          ))}
      </>
    )
  }

  return (
    <>
      {AppNavigation.filter((i) => !i.role || currentUser?.roles?.includes(i.role)).map(({ headerText, path }) => (
        <MNavLink key={String(path)} path={path}>
          {headerText}
        </MNavLink>
      ))}
      <AddProjectDialog />
      <HelpHeaderItem />
      <MUserMenu user={currentUser} 
      profileMenuItems = {profileRouteItems()}
      />
    </>
  );
});

export default HeaderInfo;
